import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeJsonParse'
})
export class SafeJsonParsePipe implements PipeTransform {
  transform(value: string): any {
    try {
      return JSON.parse(value);
    } catch (e) {
      console.error('Error parsing JSON:', e);
      return null;
    }
  }
}